import { ActionIcon, Popover } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconInfoCircle } from '@tabler/icons-react';
import React from 'react';

interface InputInformationProps {
  description: string;
}

export const InputInformation: React.FC<InputInformationProps> = ({ description }) => {
  const [opened, { open, close }] = useDisclosure(false);
  return (
    <Popover width={200} position='bottom' withArrow shadow='md' opened={opened}>
      <Popover.Target>
        <ActionIcon
          onMouseEnter={open}
          onMouseLeave={close}
          variant='transparent'
          aria-label='Information'
        >
          <IconInfoCircle style={{ width: '70%', height: '70%' }} color='grey' stroke={1.5} />
        </ActionIcon>
      </Popover.Target>
      <Popover.Dropdown style={{ pointerEvents: 'none' }}>
        <div dangerouslySetInnerHTML={{ __html: description }} />
      </Popover.Dropdown>
    </Popover>
  );
};
